<template>
  <div class="flex flex-col px-3">
    <div class="h-[36vh] w-full animate-pulse rounded-2xl bg-secondary" />
  </div>
</template>
